import hero_image from 'surveys/insomnia_funnel/paywall/assets/hero_image_1.png';
import styles from './RiseClinicHero.module.css';

export const RiseClinicHero = () => {
  return (
    <div className={styles.container}>
      <div className={styles.heroImageWrapper}>
        <img src={hero_image} alt="Sleep expert" className={styles.heroImage} />
      </div>
    </div>
  );
};
